import React from 'react'
import TextLabel from './TextLabel'
import { t } from 'i18next'
import { generateAppropriateDate } from './DateUtils'
function PickupTargetTime({ timeString }) {
  
  return (
      <TextLabel title={t("report.mis.column.label.rawDump.pickupTarget") + ` : ${generateAppropriateDate(timeString)}`} />
  )
}

export default PickupTargetTime